import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  randomPassword(longueur: number = 10): string {
    const characters = {
      minuscules: 'abcdefghjkmnpqrstuvwxyz',
      majuscules: 'ABCDEFGHJKLMNPQRSTUVWXYZ',
      chiffres: '23456789',
      specials: '!@#$%^&*()_+-=[]{}|;:,.<>?'
    };

    // Combinaison de tous les caractères possibles
    const tousLesCaracteres =
      characters.minuscules +
      characters.majuscules +
      characters.chiffres +
      characters.specials;

    let password = '';

    // Garantir au moins 1 caractère de chaque type
    password += characters.minuscules.charAt(Math.floor(Math.random() * characters.minuscules.length));
    password += characters.majuscules.charAt(Math.floor(Math.random() * characters.majuscules.length));
    password += characters.chiffres.charAt(Math.floor(Math.random() * characters.chiffres.length));
    password += characters.specials.charAt(Math.floor(Math.random() * characters.specials.length));

    // Remplir le reste aléatoirement
    for (let i = password.length; i < longueur; i++) {
      password += tousLesCaracteres.charAt(Math.floor(Math.random() * tousLesCaracteres.length));
    }

    // Mélanger le mot de passe pour éviter un motif prévisible
    return password.split('').sort(() => Math.random() - 0.5).join('');
  }

}
